import React, { useCallback } from 'react';
import { Text } from '@qga/roo-ui/components';
import { QH_DREAM_PLANNER_URL } from 'config';
import { useDataLayer } from 'hooks/useDataLayer';
import ExternalLink from 'components/ExternalLink';

const DreamPlannerLink = () => {
  const { emitInteractionEvent } = useDataLayer();

  const onClick = useCallback(() => {
    emitInteractionEvent({ type: 'Member Favourites Button', value: 'View Dream Planner Selected' });
  }, [emitInteractionEvent]);

  return (
    <ExternalLink
      color="greys.steel"
      href={QH_DREAM_PLANNER_URL}
      onClick={onClick}
      rel="noopener noreferrer"
      target="_blank"
      mr={4}
      aria-label="Dream Planner (opens in new tab)"
      data-testid="dream-planner"
    >
      <Text textDecoration="underline">Dream Planner</Text>
    </ExternalLink>
  );
};

export default DreamPlannerLink;
